// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"11df8b5d","703":"13ec4f6d","949":"42b28648"}[chunkId] + ".chunk.js";
};